import { useCallback, useState } from 'react';
import Button from '@/components/Button';
import { EVENTS, gtag } from '@/lib/gtag';
import IconComputerDesktop from '@/assets/icons/computer-desktop.svg?react';
import ScreenShareManager from './ScreenShareManager';

export default function ButtonScreenShare() {
  const [shareSessionId, setShareSessionId] = useState<number | null>(null);
  const isScreenShareEnabled = shareSessionId !== null;

  const handleToggleScreenShare = useCallback(() => {
    console.log('share screen button clicked.');
    
    if (isScreenShareEnabled) {
      // Stop current session
      setShareSessionId(null);
    } else {
      // Start new session with unique ID
      setShareSessionId(Date.now());
    }
    
    gtag(EVENTS.SCREEN_SHARE);
  }, [isScreenShareEnabled]);

  return (
    <>
      <Button
        title="Share screen"
        onClick={handleToggleScreenShare}
        className="mx-1"
        variant="default"
        size="icon"
        faded={!isScreenShareEnabled}>
        <IconComputerDesktop className="w-6 h-6" />
      </Button>

      {shareSessionId && (
        <ScreenShareManager
          key={shareSessionId}
          onStop={() => setShareSessionId(null)}
        />
      )}
    </>
  );
}
